import { render, staticRenderFns } from "./newddaconfig.vue?vue&type=template&id=05951d1e"
import script from "./newddaconfig.vue?vue&type=script&lang=js"
export * from "./newddaconfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports